$(document).ready(function(){
  $('.popup').show();
  //open popup
  $(document).on('click', '.popup-trigger', function(event){
    event.preventDefault();
    $('.popup').addClass('is-visible');
    $('body').addClass('is-visible');
    // magnify js start
    if ($(".popup").hasClass("is-visible")) {
      var magnifierSize = 125; // zoom magnifier size
      var magnification = 4;
      function magnifier() {
        this.magnifyImg = function(ptr, magnification, magnifierSize) {
        var $pointer;
        if (typeof ptr == "string") {
          $pointer = $(ptr);
        } else if (typeof ptr == "object") {
          $pointer = ptr;
        }
    
        if(!($pointer.is('img'))){
          alert('Object must be image.');
          return false;
        }
    
        magnification = +(magnification);
    
        $pointer.hover(function() {
          // $(this).css('cursor', 'none');
          $('.magnify').show();
          var width = $(this).width();
          var height = $(this).height();
          var src = $(this).attr('src');
          var imagePos = $(this).offset();
          var image = $(this);
    
          if (magnifierSize == undefined) {
            magnifierSize = '150px';
          }
    
          $('.magnify').css({
            'background-size': width * magnification + 'px ' + height * magnification + "px",
            'background-image': 'url("' + src + '")',
            'width': magnifierSize,
            'height': magnifierSize
          });
    
          var magnifyOffset = +($('.magnify').width() / 2);
          var rightSide = +(imagePos.left + $(this).width());
          var bottomSide = +(imagePos.top + $(this).height());
    
          $(document).mousemove(function(e) {
            if (e.pageX < +(imagePos.left - magnifyOffset / 6) || e.pageX > +(rightSide + magnifyOffset / 6) || e.pageY < +(imagePos.top - magnifyOffset / 6) || e.pageY > +(bottomSide + magnifyOffset / 6)) {
              $('.magnify').hide();
              $(document).unbind('mousemove');
            }
            var backgroundPos = "" - ((e.pageX - imagePos.left) * magnification - magnifyOffset) + "px " + -((e.pageY - imagePos.top) * magnification - magnifyOffset) + "px";
            $('.magnify').css({
              'left': e.pageX - magnifyOffset,
              'top': e.pageY - magnifyOffset,
              'background-position': backgroundPos
            });
          });
        }, function() {
    
        });
      };
    
      this.init = function() {
        $('body').prepend('<div class="magnify"></div>');
      }
    
      return this.init();
    }
    var magnify = new magnifier();
    magnify.magnifyImg('img.magnifiedImg', magnification, magnifierSize);
  }
    // magnify js end

    var pdpImgSrc = $(this).data("imgsrc");
    $(".magnifiedImg").each(function(){
      var popupImgSrc = $(this).data("popimgsrc");
      var slickIndex = $(this).parent().data("slick-index");
      if(pdpImgSrc == popupImgSrc){
        $('.slider-nav-pdp').slick('slickGoTo', slickIndex);
        $(".popup-container .slick-track").css("transform", "none");
      }
      
    });
    
  });

   $(document).on('wheel', function(event){
    var thumb_length = $(".popup-container .thumbnail-image").length;
     if($(window).width() > 768 && thumb_length == 5){
       setInterval(function(){
         
       $(".popup-container .slick-track").css("transform", "none");
         }, 200);
     }
   });

  //close popup
  $(document).on('click', '.popup', function(event){
    if( $(event.target).is('.popup-close') || $(event.target).is('.popup') ) {
      event.preventDefault();
      $(this).removeClass('is-visible');
      $(document).find(".magnify").remove();
      $('body').removeClass('is-visible');
      // $(".popup-trigger").removeAttr("style");
    }
  });

  $(".slider-for-pdp").slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav-pdp"
  });
  $(".slider-nav-pdp").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".slider-for-pdp",
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
          {
        breakpoint: 1300,
        settings: {
          vertical: true,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1201,
        settings: {
          vertical: false,
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          vertical: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 380,
        settings: {
          vertical: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});